<template>
  <div class="app-gallery">
    <slot />
  </div>
</template>

<script>
// TODO: Remove this component. This doesn't make sense as this is only used inside the Activities.
const DEFAULT_OPTIONS = {
  selector: '.gallery-item',
  thumbnail: true,
  showThumbByDefault: false,
  hideControlOnEnd: true,
  download: false,
  fullScreen: false,
  actualSize: false,
  zoom: false,
  preload: 3,
  allowHtmlCaptions: false,
  allowCaptionLookups: false,
  getCaptionsFromTitleOrAlt: false,
  hash: false,
};
const AFTER_OPEN_EVENT = 'onAfterOpen.lg';
const BEFORE_CLOSE_EVENT = 'onBeforeClose.lg';
const LOAD_ERROR_EVENT = 'onLoadError.lg';
const BEFORE_NEXT_EVENT = 'onBeforeNextSlide.lg';
const BEFORE_PREV_EVENT = 'onBeforePrevSlide.lg';

export default {
  name: 'AppGallery',
  provide() {
    return {
      $appGallery: this,
    };
  },
  props: {
    galleryOptions: {
      type: Object,
      default: () => ({}),
    },
    fallbackImageUrl: {
      type: String,
    },
  },
  data() {
    return {
      dynamicEl: [],
      galleryInstance: null,
    };
  },
  unmounted() {
    this.destroyGallery();
  },
  methods: {
    addItem(item) {
      this.dynamicEl.push(item);
    },
    openItemByIndex(index) {
      if (!this.galleryMounted) {
        this.mountGallery(index);
        this.galleryMounted = true;
      } else {
        this.galleryInstance.build(index);
      }
    },
    mountGallery(index) {
      const $el = $(this.$el);
      const options = Object.assign({}, DEFAULT_OPTIONS, this.galleryOptions);

      if (options.dynamic) {
        options.dynamicEl = this.dynamicEl;
      }

      if (typeof index !== 'undefined' && index !== null) {
        options.index = index;
      }

      $el.lightGallery(options);
      this.galleryInstance = $el.data('lightGallery');

      $el.on(AFTER_OPEN_EVENT, () => {
        this.$emit('gallery-openened');
      });

      $el.on(BEFORE_CLOSE_EVENT, () => {
        this.$emit('gallery-closed');
      });

      if (this.fallbackImageUrl) {
        $el.on(LOAD_ERROR_EVENT, (_event, index) => {
          const $image = this.galleryInstance.$slide.eq(index).find('.lg-image');

          $image.attr('src', this.fallbackImageUrl);
        });
      }

      $el.on(BEFORE_NEXT_EVENT, () => {
        this.trackArrowClick('next');
      });

      $el.on(BEFORE_PREV_EVENT, () => {
        this.trackArrowClick('previous');
      });
    },
    destroyGallery() {
      if (this.galleryInstance) {
        const $el = this.galleryInstance.$el;

        $el.off(AFTER_OPEN_EVENT).off(BEFORE_CLOSE_EVENT);
        this.galleryInstance.destroy(true);
        this.galleryInstance = null;
      }
    },
    trackArrowClick(direction) {
      window.analytics?.track('Screenshot arrow selected', { direction });
    },
  },
};
</script>
